var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_186",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5918 2.32653H4.18368C3.11348 2.32653 2.2449 3.1951 2.2449 4.26531V16.6735C2.2449 17.7437 3.11348 18.6122 4.18368 18.6122H16.5918C17.662 18.6122 18.5306 17.7437 18.5306 16.6735V4.26531C18.5306 3.1951 17.662 2.32653 16.5918 2.32653ZM7.28572 8.53062V15.898H4.95919V8.53062H7.28572ZM4.95919 6.38633C4.95919 5.84347 5.4245 5.42857 6.12245 5.42857C6.82041 5.42857 7.25858 5.84347 7.28572 6.38633C7.28572 6.92919 6.85143 7.36735 6.12245 7.36735C5.4245 7.36735 4.95919 6.92919 4.95919 6.38633ZM15.8163 15.898H13.4898C13.4898 15.898 13.4898 12.3074 13.4898 12.0204C13.4898 11.2449 13.102 10.4694 12.1327 10.4539H12.1016C11.1633 10.4539 10.7755 11.2527 10.7755 12.0204C10.7755 12.3733 10.7755 15.898 10.7755 15.898H8.44899V8.53062H10.7755V9.52327C10.7755 9.52327 11.5239 8.53062 13.0284 8.53062C14.5678 8.53062 15.8163 9.58919 15.8163 11.7335V15.898Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_186)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.22449,
    y: -8.91837,
    width: 34.898,
    height: 32.9592,
    fill: "#05386B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.bdae80301143813efcdefdfb9dbf2b2c.svg";
export { ForwardRef as ReactComponent };